import OrtivisAvatarPreview from "components/onboarding/ortivis/OrtivisAvatarPreview";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Confetti } from "@neoconfetti/react";

const largeProps = {
	force: 0.8,
	duration: 3000,
	particleCount: 300,
	width: 1600,
	colors: ["#FF5733", "#FFD700", "#32CD32", "#FF69B4", "#00BFFF"],
	zIndex: 999999999,
};

const OrtivisEndQuizMultiplayer = ({ quizId, room }) => {
	const [isLargeExploding, setIsLargeExploding] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		setIsLargeExploding(true);
	}, []);

	// Ensure players exist
	const sortedPlayers = [...(room?.players ?? [])].sort(
		(a, b) => (b.score || 0) - (a.score || 0)
	);

	// Extract the top 3 players for the podium
	const [first, second, third] = sortedPlayers;

	return (
		<div className="flex relative flex-col items-center w-full h-full min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white p-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)]">
			<h1 className="text-lg font-bold">🏆 Partie terminée!</h1>
			{/* 🏅 Podium Display */}
			{isLargeExploding && <Confetti {...largeProps} />}
			<div className="flex items-end justify-center w-full mt-4">
				{/* 2nd Place */}
				{second && (
					<div className="relative flex flex-col items-center w-20">
						<OrtivisAvatarPreview avatar={second.avatar} />
						<div className="flex flex-col w-20 h-14 bg-gray-400 shadow-md rounded-t-lg items-center justify-start text-white">
							<p className="font-bold">{second.pseudo}</p>
							<p>{second.score} pts</p>
						</div>
					</div>
				)}

				{/* 1st Place */}
				{first && (
					<div className="relative flex flex-col items-center w-24">
						<OrtivisAvatarPreview avatar={first.avatar} />
						<div className="flex flex-col w-24 h-16 bg-yellow-500 shadow-md rounded-t-lg items-center justify-start text-white">
							<p className="font-bold">{first.pseudo}</p>
							<p>{first.score} pts</p>
						</div>
					</div>
				)}

				{/* 3rd Place */}
				{third && (
					<div className="relative flex flex-col items-center w-20">
						<OrtivisAvatarPreview avatar={third.avatar} />
						<div className="flex flex-col w-20 h-12 bg-amber-600 shadow-md rounded-t-lg items-center justify-start text-white">
							<p className="font-bold">{third.pseudo}</p>
							<p>{third.score} pts</p>
						</div>
					</div>
				)}
			</div>
			{/* 📜 Classement List */}
			<div className="relative p-2 w-full overflow-y-auto mt-4">
				<h3 className="mb-2 font-bold">Classement:</h3>
				<ul>
					{sortedPlayers.map((player, index) => (
						<li
							key={player.id || index} // Fallback key for safety
							className={`px-2 text-sm border-b ${
								index < 3 ? "text-gray-500" : "text-orange-500"
							}`}
						>
							{index + 1}. {player.pseudo} - {player.score || 0} pts
						</li>
					))}
				</ul>
			</div>
			{/* 🆕 New Game Button */}
			<div className="w-full mt-8 z-50 relative flex justify-center">
				<button
					onClick={() => navigate(`/start/${quizId}`)} // Add navigation logic
					className="mt-2 rounded-full px-6 py-3 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
				>
					Lancer une nouvelle session
				</button>
			</div>
		</div>
	);
};

export default OrtivisEndQuizMultiplayer;
